<template>
  <vs-popup class="customer-account-limit-request-update-popup"
            id="popup"
            title="VIEW ACCOUNT LIMIT REQUEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <template slot="actions">
        <vs-chip style="border-radius: 0px" transparent color="dark">
          status: {{ createForm.status }}
        </vs-chip>
      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form  autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="change_to" name="change_to" rules="required" v-slot="{ errors }">
                <small class="label">Change To</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{__accountCurrency()}}</span>
                    </div>
                  </template>
                  <vs-input readonly v-model="createForm.change_to"  name="change_to" class="w-full" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="reason_for_change" name="reason_for_change" rules="required" v-slot="{ errors }">
                <small class="label">Reason for Change</small>
                <vs-textarea readonly class="mb-0" v-model="createForm.reason_for_change" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button class="ml-auto mt-2" @click="open = false">Close</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createForm: {},
      id: ''
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.$vs.loading();
        await this.fetchCustomerAccountLimitRequest()
        this.$vs.loading.close();
        this.open = true;
      } catch (error) {

      }
    },

    async fetchCustomerAccountLimitRequest() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getAccountLimitRequest(this.id)
      this.createForm =  data.data
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {},
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-account-limit-request-update-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
